export const UnitImagesTypes = {
    Architecture: 1,
    Interior: 2,
}